import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { GameConfig, GameState, POINTS_PER_LEVEL, maxRevives, REVIVE_COUNTDOWN_START, ADV_ROUND } from '@utils/game/tapUp/constants.js';
import { audioManager } from '@utils/game/tapUp/audioManager.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "tapUpPage",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    nextBtnText() {
      return (this.GameConfig.level + 1) % ADV_ROUND === 0 ? this.$lang('Continue (Ad)') : this.$lang('Next Level');
    }
  },
  data() {
    return {
      GameConfig,
      CANVAS_WIDTH: 0,
      CANVAS_HEIGHT: 0,
      GROUND_Y: 0,
      POINTS_PER_LEVEL,
      REVIVE_COUNTDOWN_START,
      ADV_ROUND,
      lastScore: 0,
      leftTime: 0,
      advList: [],
      prizePool: 0,
      stimeVal: null,
      reviveTimer: 0,
      timePeriod: "",
      userReward: null,
      popWinShow: false,
      popLostShow: false,
      popStartShow: false,
      popOpenMobileShow: false,
      popUserRewardShow: false,
      popGameRankShow: false,
      gameState: GameState.MENU,
      audio: audioManager,
      player: {
        x: 60,
        y: this.GROUND_Y - 45,
        width: 32,
        height: 45,
        vy: 0,
        isGrounded: true,
        color: '#00f2ff',
        invulnerable: false
      },
      obstacles: [],
      coins: [],
      frame: 0,
      reviveTimeout: null,
      bgBuildings: 0,
      // 动态视差背景数组
      totalScore: 0,
      startTimer: null,
      startCountdown: 0
    };
  },
  watch: {
    gameState: {
      handler(newState, oldState) {
        if (newState === GameState.PLAYING) {
          this.startGameLoop();
        }
        if (newState === GameState.GAMEOVER) {
          this.popLostShow = true;
          this.end();
        }
        if (newState === GameState.LEVEL_COMPLETE) {
          this.popWinShow = true;
          this.end();
        }
        cancelAnimationFrame(this.frame);
      }
    },
    "popGameRankShow": {
      handler(newVal, oldVal) {
        if (newVal) {
          this.gameState = GameState.STOP;
        } else {
          this.startCountdown = 3;
          this.playStartDown(() => {
            this.gameState = GameState.PLAYING;
          });
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.startTimer);
    clearTimeout(this.stimeVal);
    cancelAnimationFrame(this.frame);
    this.end();
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    startGameLoop() {
      // 用箭头函数包裹，确保 this 指向 Vue 实例
      const loop = () => {
        this.update();
        if (this.gameState === GameState.PLAYING) {
          this.frame = requestAnimationFrame(loop);
        }
      };
      loop();
    },
    spawnObstacle() {
      const minGap = 400;
      const maxGap = 600;
      const lastObstacle = this.obstacles[this.obstacles.length - 1];
      if (!lastObstacle || this.CANVAS_WIDTH - lastObstacle.x > Math.random() * (maxGap - minGap) + minGap) {
        const isWall = Math.random() > 0.9;
        const height = isWall ? 75 : 45;
        this.obstacles.push({
          x: this.CANVAS_WIDTH,
          y: this.GROUND_Y - height,
          width: 24,
          height: height,
          type: isWall ? 'wall' : 'hurdle',
          speed: this.GameConfig.speed
        });
        if (Math.random() > 0.45) {
          this.coins.push({
            x: this.CANVAS_WIDTH + 5,
            y: this.GROUND_Y - height - 100 - Math.random() * 30,
            width: 22,
            height: 22,
            collected: false,
            value: this.GameConfig.coinScore
          });
        }
      }
    },
    resetGame(newLevel = 1) {
      const callback = async res => {
        this.popStartShow = false;
        this.popWinShow = false;
        await this.start();
        this.audio.init();
        if (newLevel == 1) {
          this.GameConfig.revives = this.GameConfig.maxRevives;
          this.totalScore = 0;
        }
        this.GameConfig.level = newLevel;
        this.GameConfig.score = 0;
        this.GameConfig.coins = 0;
        this.GameConfig.progress = 0;
        this.GameConfig.speed = this.GameConfig.baseSpeed + (newLevel - 1) * 0.8;
        this.player = {
          ...this.player,
          y: this.GROUND_Y - 45,
          vy: 0,
          isGrounded: true,
          invulnerable: false
        };
        this.obstacles = [];
        this.coins = [];
        this.startCountdown = 3;
        this.playStartDown(() => {
          //this.audio.startBGM();

          this.gameState = GameState.PLAYING;
        });
      };
      if (newLevel % ADV_ROUND === 0) {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } else {
        callback(null);
      }
    },
    handleCancel() {
      this.popLostShow = false;
      this.gameState = GameState.MENU;
      this.popStartShow = true;
    },
    handleRevive() {
      if (this.GameConfig.revives <= 0) return;
      const callback = res => {
        this.popLostShow = false;
        this.GameConfig.revives = this.GameConfig.revives - 1 >= 0 ? this.GameConfig.revives - 1 : 0;
        this.startCountdown = 3;
        this.playStartDown(() => {
          this.obstacles = this.obstacles.filter(obs => obs.x > this.player.x + 200 || obs.x < this.player.x);
          this.player.invulnerable = true;
          setTimeout(() => {
            this.player.invulnerable = false;
          }, 2000);
          this.gameState = GameState.PLAYING;
        });
      };
      let advData = getRandomElement(this.advList);
      if (advData) {
        gameAdv.show(advData, this.timePeriod, res => {
          callback(res);
        }, this);
      } else {
        callback(null);
      }
    },
    jump() {
      if (this.gameState === GameState.PLAYING && this.player.isGrounded) {
        this.audio.init();
        this.audio.playJump();
        this.player.vy = this.GameConfig.jumpStrength;
        this.player.isGrounded = false;
      } else if (this.gameState === GameState.MENU || this.gameState === GameState.GAMEOVER) {
        this.resetGame();
      }
    },
    update() {
      if (this.gameState !== GameState.PLAYING) return;
      const player = this.player;
      player.vy += this.GameConfig.gravity;
      player.y += player.vy;
      if (player.y > this.GROUND_Y - player.height) {
        player.y = this.GROUND_Y - player.height;
        player.vy = 0;
        player.isGrounded = true;
      }

      // 更新背景视差滚动
      this.bgBuildings.forEach(b => {
        b.x -= this.GameConfig.speed * b.speed;
        if (b.x + b.w < -150) b.x = this.CANVAS_WIDTH + 150;
      });
      this.obstacles = this.obstacles.filter(obs => {
        obs.x -= this.GameConfig.speed;
        if (!player.invulnerable && player.x < obs.x + obs.width && player.x + player.width > obs.x && player.y < obs.y + obs.height && player.y + player.height > obs.y) {
          this.audio.playCrash();
          this.gameState = GameState.GAMEOVER;
          if (this.canRevive) this.reviveTimer = REVIVE_COUNTDOWN_START;
        }
        return obs.x + obs.width > -50;
      });
      let scoreBoostedThisFrame = false;
      this.coins = this.coins.filter(coin => {
        if (coin.collected) return false;
        coin.x -= this.GameConfig.speed;
        if (player.x < coin.x + coin.width && player.x + player.width > coin.x && player.y < coin.y + coin.height && player.y + player.height > coin.y) {
          this.audio.playCollect();
          coin.collected = true;
          this.GameConfig.coins += 1;
          this.totalScore += coin.value;
          scoreBoostedThisFrame = true;
          return false;
        }
        return coin.x + coin.width > -50;
      });
      this.spawnObstacle();
      let score = Math.max(1, Math.floor(this.GameConfig.speed / 5));
      this.GameConfig.score += score;
      this.totalScore += score;
      if (this.GameConfig.score % 10 === 0 || scoreBoostedThisFrame) {
        const progressPercent = Math.min(100, this.GameConfig.score / POINTS_PER_LEVEL * 100);
        this.GameConfig.progress = progressPercent;
      }
      if (this.GameConfig.score >= POINTS_PER_LEVEL) {
        this.audio.playLevelClear();
        this.gameState = GameState.LEVEL_COMPLETE;
      }
      this.draw();
      this.frame = requestAnimationFrame(this.update);
    },
    draw() {
      const canvas = this.$refs.canvasRef;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      ctx.clearRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      const gradient = ctx.createLinearGradient(0, 0, 0, this.CANVAS_HEIGHT);
      gradient.addColorStop(0, '#020617');
      gradient.addColorStop(1, '#0f172a');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);

      // --- 绘制模糊背景层 ---
      ctx.save();
      ctx.filter = 'blur(6px)'; // 增加模糊程度
      this.bgBuildings.forEach(b => {
        ctx.fillStyle = b.color;
        ctx.fillRect(b.x, b.y, b.w, b.h);
      });
      ctx.restore();

      // 静态网格线装饰（极低对比度，不移动）
      ctx.strokeStyle = 'rgba(51, 65, 85, 0.08)';
      ctx.lineWidth = 1;
      for (let i = 0; i < this.CANVAS_WIDTH; i += 50) {
        ctx.beginPath();
        ctx.moveTo(i, 0);
        ctx.lineTo(i, this.GROUND_Y);
        ctx.stroke();
      }

      // 地面细节（增加平滑的纹理滚动，增加速度感但减少眩晕）
      ctx.fillStyle = '#020617';
      ctx.fillRect(0, this.GROUND_Y, this.CANVAS_WIDTH, this.CANVAS_HEIGHT - this.GROUND_Y);
      ctx.strokeStyle = 'rgba(59, 130, 246, 0.15)'; // 降低对比度
      ctx.lineWidth = 1;
      const groundOffset = this.GameConfig.score * 1.5 % 100;
      for (let i = 0; i < this.CANVAS_WIDTH + 100; i += 100) {
        ctx.beginPath();
        ctx.moveTo(i - groundOffset, this.GROUND_Y);
        ctx.lineTo(i - groundOffset + 15, this.GROUND_Y + 100);
        ctx.stroke();
      }
      ctx.strokeStyle = 'rgba(59, 130, 246, 0.3)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(0, this.GROUND_Y);
      ctx.lineTo(this.CANVAS_WIDTH, this.GROUND_Y);
      ctx.stroke();

      // 玩家（清晰层，不模糊）
      const p = this.player;
      if (!p.invulnerable || Math.floor(Date.now() / 150) % 2 === 0) {
        ctx.fillStyle = p.color;
        ctx.shadowBlur = 10;
        ctx.shadowColor = p.color;
        ctx.fillRect(p.x, p.y, p.width, p.height);
        ctx.shadowBlur = 0;
      }

      // 障碍物（清晰层，不模糊）
      this.obstacles.forEach(obs => {
        ctx.fillStyle = obs.type === 'wall' ? '#ef4444' : '#f97316';
        ctx.shadowBlur = 5;
        ctx.shadowColor = ctx.fillStyle;
        ctx.fillRect(obs.x, obs.y, obs.width, obs.height);
        ctx.shadowBlur = 0;
      });

      // 金币
      this.coins.forEach(coin => {
        const bob = Math.sin(Date.now() / 250) * 4;
        ctx.fillStyle = '#fbbf24';
        ctx.shadowBlur = 15;
        ctx.shadowColor = '#fbbf24';
        ctx.beginPath();
        ctx.arc(coin.x + coin.width / 2, coin.y + coin.height / 2 + bob, coin.width / 2, 0, Math.PI * 2);
        ctx.fill();
        ctx.shadowBlur = 0;
      });
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "tapUp"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
      });
    },
    async end() {
      if (this.lastScore >= this.totalScore) return;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "tapUp",
        level: this.GameConfig.level,
        score: this.totalScore,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "tapUp"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.userReward = rs.data.userReward ?? null;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(async () => {
        if (this.leftTime <= 0) {
          await this.init();
          this.gameState = GameState.MENU;
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.end();
        this.popGameRankShow = true;
      });
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "tapUp"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    },
    playStartDown(callback) {
      clearInterval(this.startTimer);
      this.startTimer = setInterval(() => {
        this.audio.playTick();
        this.startCountdown--;
        if (this.startCountdown <= 0) {
          clearInterval(this.startTimer);
          callback?.();
        }
      }, 1000);
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    this.gameState = GameState.MENU;
    const gameCenterBox = this.$refs.gameCenterBox;
    this.CANVAS_WIDTH = gameCenterBox.clientWidth;
    this.CANVAS_HEIGHT = gameCenterBox.clientHeight;
    this.GROUND_Y = this.CANVAS_HEIGHT - 80;
    const buildings = [];
    for (let i = 0; i < 15; i++) {
      const isFar = Math.random() > 0.4;
      buildings.push({
        x: Math.random() * this.CANVAS_WIDTH * 2,
        y: this.GROUND_Y - (isFar ? 350 : 250),
        w: isFar ? 120 : 80,
        h: isFar ? 450 : 300,
        speed: isFar ? 0.03 : 0.08,
        // 速度进一步减慢，增加稳定性
        color: isFar ? 'rgba(15, 23, 42, 0.3)' : 'rgba(30, 41, 59, 0.2)'
      });
    }
    this.bgBuildings = buildings;
    this.popStartShow = true;
  }
};